import React, {
  useRef,
  useState,
  useEffect,
  useCallback
} from 'react';
import FinancingTermsModal, {
  TERMS_VERSION
} from './FinancingTermsModal'
import {
  getAllStates,
  getLocalGovernments
} from '@eh1z/nigerian-locations'

import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function ApplyForLoan() {


  const [sameAddress, setSameAddress] =
  useState(false)

  const navigate = useNavigate();

  const {
  url,
  currentUser
} = useSelector(state => state)


  // FORM REFS

const loanRef = useRef()
const landlordPhoneRef = useRef()


// CUSTOMER ADDRESS

const [customerState, setCustomerState] =
  useState('')

const [customerLga, setCustomerLga] =
  useState('')

const [customerAddress, setCustomerAddress] =
  useState('')


// RENTAL PROPERTY ADDRESS

const [propertyState, setPropertyState] =
  useState('')

const [propertyLga, setPropertyLga] =
  useState('')

const [propertyAddress, setPropertyAddress] =
  useState('')

// LANDLORD PHYSICAL ADDRESS

const [landlordState, setLandlordState] =
  useState('')

const [landlordLga, setLandlordLga] =
  useState('')

const [landlordAddress, setLandlordAddress] =
  useState('')


const states = getAllStates()

const customerLgas =
  customerState
    ? getLocalGovernments(customerState)
    : []

const propertyLgas =
  propertyState
    ? getLocalGovernments(propertyState)
    : []

  const landlordLgas =
  landlordState
    ? getLocalGovernments(landlordState)
    : []


  // BANKS

  const [banks, setBanks] = useState([]);

  const [selectedLandLordBank, setSelectedLandLordBank] =
    useState('');

  const [landLordAccountNumber, setLandLordAccountNumber] =
    useState('');

  const [landLordAccountName, setLandLordAccountName] =
    useState('');

  const [landLordBankName, setLandLordBankName] =
    useState('');


  // VERIFICATION

  const [verifyingAccount, setVerifyingAccount] =
    useState(false);

  const [accountVerified, setAccountVerified] =
    useState(false);

  const [verificationError, setVerificationError] =
    useState('');


  // FORM

  const [submitting, setSubmitting] =
    useState(false);

  const [error, setError] =
    useState('');

    // FINANCING AGREEMENT

const [termsOpen, setTermsOpen] =
  useState(false)

const [termsAccepted, setTermsAccepted] =
  useState(false)

const [signatureName, setSignatureName] =
  useState('')



  const normalizeName = (name = '') => {

  return name
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()

}


const signatureMatches =
  Boolean(currentUser?.fullname) &&
  Boolean(signatureName.trim()) &&
  normalizeName(signatureName) ===
  normalizeName(currentUser.fullname)


  // GET BANKS

  const getBanks = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/auth/get-banks`,
        {
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem('access_token')}`
          }
        }
      );
      setBanks(response.data);

    } catch (error) {
      console.error(
        "Error getting banks:",
        error
      );
      setError(
        "Unable to load banks."
      );
    }
  }, [url]);


  // VERIFY LANDLORD BANK ACCOUNT

  const verifyAccount = useCallback(async () => {
    if (
      landLordAccountNumber.length !== 10 ||
      !selectedLandLordBank
    ) {
      return;
    }
    try {
      setVerifyingAccount(true);
      setVerificationError('');
      setAccountVerified(false);
      setLandLordAccountName('');
      setLandLordBankName('');

      const formData = new FormData();
      formData.append(
        'account_number',
        landLordAccountNumber
      );

      formData.append(
        'bank_code',
        selectedLandLordBank
      );


      const response = await axios.post(
        `${url}/auth/verify-account`,
        formData,
        {
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem('access_token')}`
          }
        }
      );

      const account = response.data.data;
      setLandLordAccountName(
        account.account_name
      );
      setLandLordBankName(
        account.bank_name
      );
      setAccountVerified(true);
    } catch (error) {

      console.error(error);
      setAccountVerified(false);
      setLandLordAccountName('');
      setLandLordBankName('');
      setVerificationError(
        error.response?.data?.detail ||
        'Unable to verify this account.'
      );
    } finally {
      setVerifyingAccount(false);
    }
  }, [
    url,
    landLordAccountNumber,
    selectedLandLordBank
  ]);


  // LOAD BANKS

  useEffect(() => {
    getBanks();
  }, [getBanks]);


  // AUTO VERIFY WHEN 10 DIGITS + BANK EXIST

  useEffect(() => {
    if (
      landLordAccountNumber.length === 10 &&
      selectedLandLordBank
    ) {
      verifyAccount();
    } else {
      setAccountVerified(false);
      setLandLordAccountName('');
      setLandLordBankName('');
      setVerificationError('');
    }
  }, [
    landLordAccountNumber,
    selectedLandLordBank,
    verifyAccount
  ]);


  // HANDLE ACCOUNT NUMBER

  const handleAccountNumber = (e) => {
    const value =
      e.target.value.replace(/\D/g, '');
    setLandLordAccountNumber(
      value.slice(0, 10)
    );
  };


  // SUBMIT LOAN

  const getLoan = async () => {

  setError('')


  if (
    !customerState ||
    !customerLga ||
    !customerAddress.trim()
  ) {

    setError(
      'Please complete your current house address.'
    )

    return
  }


  if (
    !sameAddress &&
    (
      !propertyState ||
      !propertyLga ||
      !propertyAddress.trim()
    )
  ) {

    setError(
      'Please complete the rental property address.'
    )

    return
  }


  if (
    !landlordState ||
    !landlordLga ||
    !landlordAddress.trim()
  ) {

    setError(
      "Please complete your landlord's physical address."
    )

    return
  }


  if (!accountVerified) {

    setError(
      'Please provide a valid verified landlord bank account.'
    )

    return
  }


    if (!termsAccepted) {

      setError(
        'Please read and accept the RentHub Financing Agreement.'
      )

      return
    }


    if (!signatureMatches) {

      setError(
        'Please type your registered full legal name to sign the financing agreement.'
      )

      return
    }


    try {
      setSubmitting(true);
      const fullCustomerAddress = [
        customerAddress.trim(),
        customerLga,
        customerState,
        'Nigeria'
      ].join(', ')


    const fullPropertyAddress =
    sameAddress
      ? fullCustomerAddress
      : [
          propertyAddress.trim(),
          propertyLga,
          propertyState,
          'Nigeria'
        ].join(', ')

      
    const fullLandlordAddress = [
      landlordAddress.trim(),
      landlordLga,
      landlordState,
      'Nigeria'
    ].join(', ')


      const formData = new FormData();
      formData.append(
        'address',
        fullCustomerAddress
      )
      formData.append(
        'rent_amount',
        loanRef.current.value
      );
      formData.append(
        'property_address',
        fullPropertyAddress
      )
      formData.append(
        'landlord_address',
        fullLandlordAddress
      )
      formData.append(
        'landlord_phone_number',
        landlordPhoneRef.current.value
      );
      formData.append(
        'landlord_account_number',
        landLordAccountNumber
      );
      formData.append(
        'landlord_account_bank',
        selectedLandLordBank
      );
      formData.append(
        'landlord_account_name',
        landLordAccountName
      );
      formData.append(
        'terms_accepted',
        termsAccepted ? 'true' : 'false'
      )
      formData.append(
        'terms_version',
        TERMS_VERSION
      )
      formData.append(
        'terms_signature_name',
        signatureName.trim()
      )

      const response = await axios.post(
        `${url}/auth/get-loan`,
        formData,
        {
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem('access_token')}`
          }
        }
      );

      if (response.data.message) {
        alert(`Your loan application is ${response.data.decision}`);
        navigate('/dashboard/home');
        return;
      }
      setError(
        'Error submitting loan application.'
      )

    } catch (err) {
      console.log(
        "Full error:",
        err.response?.data
      );
      if (
        err.response?.status === 422 &&
        Array.isArray(err.response?.data?.detail)
      ) {
        setError(err.response.data.detail.map(item =>`${item.loc.join(".")}: ${item.msg}`).join("\n"));
      } else {
        setError(
          err.response?.data?.detail ||
          'Something went wrong.'
        );
      }
    } finally {
      setSubmitting(false);
    }
  };


  return (

    <div className="
      min-h-screen
      bg-gray-50
      flex
      justify-center
      px-4
      py-10
      font-[Lexend]
    ">

      <div className="
        bg-white
        w-full
        max-w-3xl
        rounded-2xl
        shadow-sm
        border
        border-gray-200
        overflow-hidden
      ">

        <div className="
  px-6
  md:px-10
  pt-6
">

  <button
    type="button"
    onClick={() =>
      navigate('/dashboard/home')
    }
    className="
      inline-flex
      items-center
      gap-2
      text-sm
      font-semibold
      text-gray-500
      hover:text-gray-900
      transition
    "
  >
    <span className="text-lg">
      ←
    </span>

    Back to dashboard

  </button>

</div>


        {/* HEADER */}

        <div className="
          px-6
          md:px-10
          py-8
          border-b
          border-gray-100
        ">

          <h1 className="
            text-2xl
            font-bold
            text-gray-900
          ">
            Apply for Rent Loan
          </h1>

          <p className="
            text-gray-500
            text-sm
            mt-2
          ">
            Enter your rent and landlord payment details.
          </p>

        </div>


        <div className="
          px-6
          md:px-10
          py-8
          space-y-8
        ">


          {/* ERROR */}

          {error && (

            <div className="
              bg-red-50
              text-red-600
              border
              border-red-100
              rounded-lg
              p-4
              text-sm
              whitespace-pre-line
            ">
              {error}
            </div>

          )}


          {/* CUSTOMER SECTION */}

          <section>

            <h2 className="
              text-lg
              font-bold
              text-gray-900
              mb-5
            ">
              Rent Details
            </h2>


            <div className="space-y-5">


              <div>

  <FieldLabel>
    Current House Address
  </FieldLabel>

  <div className="
    grid
    grid-cols-1
    md:grid-cols-2
    gap-4
    mt-5
  ">

    <div>

      <label className="
        block
        text-xs
        font-semibold
        text-gray-500
        mb-2
      ">
        State
      </label>

      <select
        value={customerState}
        onChange={(e) => {

          setCustomerState(
            e.target.value
          )

          setCustomerLga('')

        }}
        className={inputStyle}
      >

        <option value="">
          Select state
        </option>

        {states.map(state => (

          <option
            key={state}
            value={state}
          >
            {state}
          </option>

        ))}

      </select>

    </div>


    <div>

      <label className="
        block
        text-xs
        font-semibold
        text-gray-500
        mb-2
      ">
        LGA
      </label>

      <select
        value={customerLga}
        disabled={!customerState}
        onChange={(e) =>
          setCustomerLga(
            e.target.value
          )
        }
        className={inputStyle}
      >

        <option value="">
          {
            customerState
              ? 'Select LGA'
              : 'Select state first'
          }
        </option>

        {customerLgas.map(lga => (

          <option
            key={lga}
            value={lga}
          >
            {lga}
          </option>

        ))}

      </select>

    </div>

  </div>


  <div className="mt-4">

    <label className="
      block
      text-xs
      font-semibold
      text-gray-500
      mb-2
    ">
      House Number & Street Address
    </label>

    <textarea
      value={customerAddress}
      onChange={(e) =>
        setCustomerAddress(
          e.target.value
        )
      }
      rows="2"
      placeholder="e.g. 14 Allen Avenue"
      className={inputStyle}
    />

  </div>

</div>


              <FieldLabel>
                Annual Rent Amount
              </FieldLabel>

              <input
                ref={loanRef}
                type="number"
                min="1"
                placeholder="e.g. 500000"
                className={inputStyle}
              />


<div
  className="
    border
    border-gray-200
    bg-gray-50
    rounded-xl
    p-4
  "
>

  <label
    className="
      flex
      items-start
      gap-3
      cursor-pointer
    "
  >

    <input
      type="checkbox"
      checked={sameAddress}
      onChange={(e) =>
        setSameAddress(
          e.target.checked
        )
      }
      className="
        mt-1
        w-4
        h-4
        accent-green-600
        cursor-pointer
      "
    />

    <div>

      <p className="
        text-sm
        font-semibold
        text-gray-800
      ">
        Property address is the same
        as my current house address
      </p>

      <p className="
        text-xs
        text-gray-500
        mt-1
      ">
        We'll use your current house
        address as the property address.
      </p>

    </div>

  </label>

</div>


<div
  className={`
    transition-all
    duration-200

    ${
      sameAddress
        ? `
          opacity-40
          blur-[1px]
          pointer-events-none
          select-none
        `
        : ''
    }
  `}
>
              <div>

  <FieldLabel>
    Property Address
  </FieldLabel>

  <p className="
    text-xs
    text-gray-400
    mt-4
    mb-4
  ">
    Address of the property RentHub
    will be financing.
  </p>


  <div className="
    grid
    grid-cols-1
    md:grid-cols-2
    gap-4
  ">

    <div>

      <label className="
        block
        text-xs
        font-semibold
        text-gray-500
        mb-2
      ">
        State
      </label>

      <select
        value={propertyState}
        onChange={(e) => {

          setPropertyState(
            e.target.value
          )

          setPropertyLga('')

        }}
        className={inputStyle}
      >

        <option value="">
          Select state
        </option>

        {states.map(state => (

          <option
            key={state}
            value={state}
          >
            {state}
          </option>

        ))}

      </select>

    </div>


    <div>

      <label className="
        block
        text-xs
        font-semibold
        text-gray-500
        mb-2
      ">
        LGA
      </label>

      <select
        value={propertyLga}
        disabled={!propertyState}
        onChange={(e) =>
          setPropertyLga(
            e.target.value
          )
        }
        className={inputStyle}
      >

        <option value="">
          {
            propertyState
              ? 'Select LGA'
              : 'Select state first'
          }
        </option>

        {propertyLgas.map(lga => (

          <option
            key={lga}
            value={lga}
          >
            {lga}
          </option>

        ))}

      </select>

    </div>

  </div>


  <div className="mt-4">

    <label className="
      block
      text-xs
      font-semibold
      text-gray-500
      mb-2
    ">
      House Number & Street Address
    </label>

    <textarea
      value={propertyAddress}
      onChange={(e) =>
        setPropertyAddress(
          e.target.value
        )
      }
      rows="2"
      placeholder="e.g. 22 Admiralty Way"
      className={inputStyle}
    />

  </div>

</div>

            </div>
            </div>

          </section>


          <hr />


          {/* LANDLORD */}

          <section>

            <h2 className="
              text-lg
              font-bold
              text-gray-900
              mb-1
            ">
              Landlord Details
            </h2>

            <p className="
              text-sm
              text-gray-500
              mb-5
            ">
              Rent will be disbursed directly to this account if your loan is approved.
            </p>


            <div className="space-y-5">


              <div>

  <FieldLabel>
    Landlord Physical Address
  </FieldLabel>

  <p className="
    text-xs
    text-gray-400
    mt-4
    mb-4
  ">
    Enter the address where the landlord
    can be physically verified.
  </p>


  <div className="
    grid
    grid-cols-1
    md:grid-cols-2
    gap-4
  ">

    <div>

      <label className="
        block
        text-xs
        font-semibold
        text-gray-500
        mb-2
      ">
        State
      </label>

      <select
        value={landlordState}
        onChange={(e) => {

          setLandlordState(
            e.target.value
          )

          setLandlordLga('')

        }}
        className={inputStyle}
      >

        <option value="">
          Select state
        </option>

        {states.map(state => (

          <option
            key={state}
            value={state}
          >
            {state}
          </option>

        ))}

      </select>

    </div>


    <div>

      <label className="
        block
        text-xs
        font-semibold
        text-gray-500
        mb-2
      ">
        LGA
      </label>

      <select
        value={landlordLga}
        disabled={!landlordState}
        onChange={(e) =>
          setLandlordLga(
            e.target.value
          )
        }
        className={inputStyle}
      >

        <option value="">
          {
            landlordState
              ? 'Select LGA'
              : 'Select state first'
          }
        </option>

        {landlordLgas.map(lga => (

          <option
            key={lga}
            value={lga}
          >
            {lga}
          </option>

        ))}

      </select>

    </div>

  </div>


  <div className="mt-4">

    <label className="
      block
      text-xs
      font-semibold
      text-gray-500
      mb-2
    ">
      House Number & Street Address
    </label>

    <textarea
      value={landlordAddress}
      onChange={(e) =>
        setLandlordAddress(
          e.target.value
        )
      }
      rows="2"
      placeholder="e.g. 18 Bode Thomas Street"
      className={inputStyle}
    />

  </div>

</div>


              <FieldLabel>
                Landlord Phone Number
              </FieldLabel>

              <input
                ref={landlordPhoneRef}
                type="tel"
                placeholder="e.g. 08012345678"
                className={inputStyle}
              />


              <FieldLabel>
                Landlord Bank
              </FieldLabel>

              <select
                value={selectedLandLordBank}
                onChange={(e) =>
                  setSelectedLandLordBank(
                    e.target.value
                  )
                }
                className={inputStyle}
              >

                <option value="">
                  Select landlord's bank
                </option>

                {banks.map(bank => (

                  <option
                    key={bank.code}
                    value={bank.nibss_bank_code}
                  >
                    {bank.name}
                  </option>

                ))}

              </select>


              <FieldLabel>
                Landlord Account Number
              </FieldLabel>

              <input
                type="text"
                inputMode="numeric"
                value={landLordAccountNumber}
                onChange={handleAccountNumber}
                maxLength={10}
                placeholder="10-digit account number"
                className={inputStyle}
              />


              {/* VERIFYING */}

              {verifyingAccount && (

                <div className="
                  bg-blue-50
                  border
                  border-blue-100
                  rounded-lg
                  p-4
                  text-sm
                  text-blue-600
                ">
                  Verifying landlord account...
                </div>

              )}


              {/* VERIFIED */}

              {accountVerified && (

                <div className="
                  bg-green-50
                  border
                  border-green-200
                  rounded-lg
                  p-4
                ">

                  <p className="
                    text-xs
                    font-bold
                    uppercase
                    text-green-600
                    mb-1
                  ">
                    Account Verified
                  </p>

                  <p className="
                    font-bold
                    text-gray-900
                  ">
                    {landLordAccountName}
                  </p>

                  <p className="
                    text-sm
                    text-gray-500
                    mt-1
                  ">
                    {landLordBankName}
                    {' • '}
                    {landLordAccountNumber}
                  </p>

                </div>

              )}


              {/* VERIFICATION ERROR */}

              {verificationError && (

                <div className="
                  bg-red-50
                  border
                  border-red-100
                  rounded-lg
                  p-4
                  text-sm
                  text-red-600
                ">
                  {verificationError}
                </div>

              )}

            </div>

          </section>


<hr />


{/* FINANCING AGREEMENT */}

<section>

  <h2
    className="
      text-lg
      font-bold
      text-gray-900
      mb-1
    "
  >
    Financing Agreement
  </h2>


  <p
    className="
      text-sm
      text-gray-500
      mb-5
    "
  >
    Review and sign the financing agreement
    before submitting your application.
  </p>


  <div
    className="
      border
      border-gray-200
      rounded-xl
      overflow-hidden
    "
  >

    {/* AGREEMENT */}

    <div
      className="
        p-5
        bg-gray-50
        border-b
        border-gray-200
        flex
        flex-col
        sm:flex-row
        sm:items-center
        justify-between
        gap-4
      "
    >

      <div>

        <p
          className="
            font-bold
            text-gray-900
          "
        >
          RentHub Rent Financing Agreement
        </p>

        <p
          className="
            text-xs
            text-gray-500
            mt-1
          "
        >
          Version {TERMS_VERSION}
        </p>

      </div>


      <button
        type="button"
        onClick={() =>
          setTermsOpen(true)
        }
        className="
          text-sm
          font-bold
          text-green-600
          hover:text-green-700
          shrink-0
        "
      >
        View financing terms
      </button>

    </div>


    <div className="p-5">

      {/* CHECKBOX */}

      <label
        className="
          flex
          items-start
          gap-3
          cursor-pointer
        "
      >

        <input
          type="checkbox"
          checked={termsAccepted}
          onChange={(e) =>
            setTermsAccepted(
              e.target.checked
            )
          }
          className="
            mt-1
            w-4
            h-4
            accent-green-600
            cursor-pointer
            shrink-0
          "
        />


        <span
          className="
            text-sm
            text-gray-700
            leading-6
          "
        >
          I have read and agree to the
          RentHub Rent Financing Agreement,
          including the credit assessment,
          physical verification, repayment,
          default and debt recovery terms.
        </span>

      </label>


      {/* SIGNATURE */}

      <div className="mt-6">

        <label
          className="
            block
            text-sm
            font-semibold
            text-gray-700
            mb-2
          "
        >
          Electronic Signature
        </label>


        <p
          className="
            text-xs
            text-gray-500
            mb-3
          "
        >
          Type your registered full name exactly
          as shown below to sign.
        </p>


        <div
          className="
            bg-gray-50
            rounded-lg
            px-4
            py-3
            mb-3
          "
        >

          <p
            className="
              text-xs
              text-gray-400
            "
          >
            Registered name
          </p>

          <p
            className="
              text-sm
              font-bold
              text-gray-900
              mt-1
            "
          >
            {currentUser?.fullname || 'Loading...'}
          </p>

        </div>


        <input
          type="text"
          value={signatureName}
          onChange={(e) =>
            setSignatureName(
              e.target.value
            )
          }
          placeholder="Type your full legal name"
          autoComplete="name"
          className={inputStyle}
        />


        {signatureName && (

          <p
            className={`
              text-xs
              mt-2
              font-semibold

              ${
                signatureMatches
                  ? 'text-green-600'
                  : 'text-red-500'
              }
            `}
          >

            {
              signatureMatches
                ? '✓ Signature matches your registered name.'
                : 'Signature must match your registered full name.'
            }

          </p>

        )}


        <p
          className="
            text-xs
            text-gray-400
            mt-4
            leading-5
          "
        >
          By signing electronically, you confirm
          that you intend this acceptance to act
          as your signature for this loan
          application.
        </p>

      </div>

    </div>

  </div>

</section>



          {/* SUBMIT */}
          
          <button
            onClick={getLoan}
            disabled={
              submitting ||
              verifyingAccount ||
              !accountVerified ||
              !termsAccepted ||
              !signatureMatches
            }
            className={`
              w-full
              py-3.5
              rounded-lg
              font-bold
              transition

              ${
                accountVerified &&
                termsAccepted &&
                signatureMatches &&
                !submitting &&
                !verifyingAccount

                  ? `
                    bg-green-600
                    text-white
                    hover:bg-green-700
                  `

                  : `
                    bg-gray-200
                    text-gray-400
                    cursor-not-allowed
                  `
              }
            `}
          >

            {submitting
              ? 'Submitting Application...'
              : 'Apply for Rent Loan'
            }

          </button>
        </div>
      </div>

      <FinancingTermsModal
            open={termsOpen}
            onClose={() =>
              setTermsOpen(false)
            }
      />

    </div>
  );
}


const inputStyle = `
  w-full
  border
  border-gray-300
  rounded-lg
  px-4
  py-3
  text-sm
  outline-none
  focus:border-green-500
  focus:ring-1
  focus:ring-green-500
`;


function FieldLabel({ children }) {

  return (

    <label className="
      block
      text-sm
      font-semibold
      text-gray-700
      mb-[-12px]
    ">
      {children}
    </label>

  );
}